module.exports = __webpack_public_path__ + "media/jam/bghead-a0136a7c.png";